import React, { useState, useEffect } from "react";
import axios from "axios";
import { useFetcher } from "react-router-dom";

const CareerOpportunities = () => {
  const [data, setData] = useState([]); // Stores career opportunities data
  const [backgroundImage, setBackgroundImage] = useState(""); // Stores background image URL
  const [buttonLink, setButtonLink] = useState("#"); // Stores button link URL

  useEffect(() => {
    async function fetchCareerData() {
      try {  
      const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/careers`);    
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events); 
        setData(events.careerOpportunitiesSection.careerOpportunities || []); 
        setBackgroundImage(events.careerOpportunitiesSection.backgroundImage || "");
        setButtonLink(events.careerOpportunitiesSection.buttonLink || "#");
      }
      catch (error) {
        console.error("Error fetching career data:", error);
      }
    }
    fetchCareerData();
  }, []);

  return (
    <div className="relative bg-cover bg-center text-white py-10 px-5"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}>
      {/* Overlay */}
      <div className="!absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">What's in it for you?</h2>

        {/* Grid for Career Opportunities */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {data.length > 0 ? (
            data.map((item, index) => (
              <div key={index} className="bg-white text-black p-6 rounded-lg shadow-lg">
                {/* Icon and Title in the Same Row */}
                <div className="flex items-center space-x-3">
                  {/* <img src={`${process.env.REACT_APP_COURSE_API_BASEURL}${item.icon}`} alt={item.title} className="w-12 h-12" /> */}
                  <img src={item.icon} alt={item.title} className="w-12 h-12"  loading="lazy" />
                  <h3 className="text-xl font-semibold">{item.title}</h3>
                </div>

                {/* Description */}
                <p className="text-gray-700 mt-3">{item.description}</p>
              </div>
            ))
          ) : (
            <p className="text-white">No career opportunities available.</p>
          )}
        </div>

        {/* Button */}
        <a href={buttonLink} className="mt-6 inline-block bg-yellow-500 text-black px-6 py-2 rounded-lg font-semibold hover:bg-yellow-600">
          Explore Opportunities
        </a>
      </div>
    </div>
  );
};

export default CareerOpportunities;
